export const FETCH_TOKEN = 'fetch_token';
export const FETCH_TOKEN_START = 'fetch_token_start';
export const FETCH_TOKEN_END = 'fetch_token_end';
export const FETCH_TOKEN_ERROR = 'fetch_token_error';

export const FETCH_ACCOUNT = 'fetch_account';
export const FETCH_ACCOUNT_START = 'fetch_account_start';
export const FETCH_ACCOUNT_END = 'fetch_account_end';
export const FETCH_ACCOUNT_ERROR = 'fetch_account_error';
export const CROSS_DOMAIN_ACCOUNT_SEARCH = 'cross_domain_account_search';
export const SET_TARGET_ACCOUNT = 'set_target_account';
export const UNSET_TARGET_ACCOUNT = 'unset_target_account';
export const REMOVE_ACCOUNT = 'remove_account';

export const FETCH_SWITCH_TYPE = 'fetch_switch_type';
export const FETCH_SWITCH_TYPE_START = 'fetch_switch_type_start';
export const FETCH_SWITCH_TYPE_END = 'fetch_switch_type_end';
export const FETCH_SWITCH_TYPE_ERROR = 'fetch_switch_type_error';
export const CLEAR_SWITCH_TYPE = 'clear_switch_type';

export const FETCH_CSR_AGENT = 'fetch_csr_agent';
export const FETCH_CSR_AGENT_START = 'fetch_csr_agent_start';
export const FETCH_CSR_AGENT_END = 'fetch_csr_agent_end';
export const FETCH_CSR_AGENT_ERROR = 'fetch_csr_agent_error';
export const SET_TARGET_AGENT = 'set_target_agent';
export const UNSET_TARGET_AGENT = 'unset_target_agent';
export const REMOVE_CSR_AGENT = 'remove_csr_agent';

export const FETCH_CSR_AGENT_REPORT = 'fetch_csr_agent_report';
export const FETCH_CSR_AGENT_REPORT_START = 'fetch_csr_agent_report_start';
export const FETCH_CSR_AGENT_REPORT_END = 'fetch_csr_agent_report_end';
export const FETCH_CSR_AGENT_REPORT_ERROR = 'fetch_csr_agent_report_error';
export const REMOVE_CSR_AGENT_REPORT = 'remove_csr_agent_report';

export const FETCH_ACCOUNT_REPORT = 'fetch_account_report';
export const FETCH_ACCOUNT_REPORT_START = 'fetch_account_report_start';
export const FETCH_ACCOUNT_REPORT_END = 'fetch_account_report_end';
export const FETCH_ACCOUNT_REPORT_ERROR = 'fetch_account_report_error';
export const REMOVE_ACCOUNT_REPORT = 'remove_account_report';

export const INITIALIZE_USER = 'initialize_user';
export const INITIALIZE_USER_ERROR = 'initialize_user_error';

export const CLEAR_ERROR = 'clear_error';
